import Games from './Games.container';

export default Games;
